import { isEmpty } from 'lodash-es';
import { createSelector } from 'reselect';
import {
  IS_USE_PLEX_API,
  LIVE_RTP_GAMES_SECTION_AMOUNT
} from '../../../constants';
import { useGamesSelector } from '../../store';
import { GamesStorageType } from '../../types';
import {
  mapAndFilterGameLaunchIds,
  selectFeedByFeedName,
  selectLaunchIdToGameId
} from '../helpers';

export const selectLiveRtpGames = (state: GamesStorageType) =>
  state.dynamicCategories.liveRtpGames;

const selectLiveRtpGamesSectionsIds = (feedName: string) =>
  createSelector(
    [
      selectLaunchIdToGameId,
      (state) => selectFeedByFeedName(state, feedName),
      selectLiveRtpGames
    ],
    (launchIdToGameId, gamesFeed, liveRtpGames) => {
      if (IS_USE_PLEX_API) {
        if (isEmpty(liveRtpGames)) {
          return [];
        }
        const prepareGames = (gamesIdsList: (string | number)[]) =>
          gamesIdsList
            .map((gameLaunchId) => launchIdToGameId[gameLaunchId])
            .filter(Boolean);

        return [
          {
            sectionId: 'hot',
            gamesIds: prepareGames(liveRtpGames.hot || []).slice(
              0,
              LIVE_RTP_GAMES_SECTION_AMOUNT
            )
          },
          {
            sectionId: 'cold',
            gamesIds: prepareGames(liveRtpGames.cold || []).slice(
              0,
              LIVE_RTP_GAMES_SECTION_AMOUNT
            )
          }
        ];
      }

      if (!gamesFeed?.isLoaded || isEmpty(liveRtpGames)) {
        return [];
      }

      return [
        {
          sectionId: 'hot',
          gamesIds: mapAndFilterGameLaunchIds(
            liveRtpGames.hot || [],
            launchIdToGameId,
            gamesFeed.gamesIds || []
          ).slice(0, LIVE_RTP_GAMES_SECTION_AMOUNT)
        },
        {
          sectionId: 'cold',
          gamesIds: mapAndFilterGameLaunchIds(
            liveRtpGames.cold || [],
            launchIdToGameId,
            gamesFeed.gamesIds || []
          ).slice(0, LIVE_RTP_GAMES_SECTION_AMOUNT)
        }
      ];
    }
  );

export const useGetLiveRtpGamesSectionsIds = ({
  feedName
}: {
  feedName: string;
}) => {
  return useGamesSelector(selectLiveRtpGamesSectionsIds, [feedName]);
};
